import { z } from 'zod';
import { BoxMechanismSchema } from './box-settings.js';
// The set of pay mechanisms one staff member is assigned to (subset of the
// box's enabled mechanisms — enforced server-side, see
// staff-mechanisms.service.ts). Most staff have exactly one (today's only
// possibility); a staff member assigned 2+ gets a consolidated salary line
// combining each mechanism's pay into one total (see payroll-mechanisms
// orchestration, not yet built).
export const StaffMechanismsSchema = z.array(BoxMechanismSchema);
//# sourceMappingURL=staff-mechanisms.js.map